const translations = {
  common: {
    search: 'Search',
    searching: 'Searching',
    signIn: 'Sign in',
    register: 'Register',
    myAccount: 'My Account',
    support: 'Support',
    followUs: 'Follow us on X/Twitter',
    proMembership: 'Pro Membership',
    new: 'New',
    proMember: 'Pro Member',
    upgrade: 'Upgrade',
    subscribe: 'Subscribe',
    manage: 'Manage',
    cancel: 'Cancel',
    close: 'Close',
    or: 'Or',
    email: 'Email address',
    continue: 'Continue',
    submit: 'Submit',
    billing: 'Billing',
    sort: 'Sort',
    language: 'Language',
    selectLanguage: 'Select Language',
    searchPlaceholder: 'Search...',
    cards: 'Cards',
    previous: 'Previous',
    next: 'Next',
    pagination: 'Pagination',
    page: 'Page',
    of: 'of',
    back: 'Back',
    backToSets: 'Back to Sets',
    error: 'An error occurred. Please try again.',
    home: 'Home',
    sets: 'Sets',
    login: 'Login',
    loginRequired: 'Please log in to access this feature',
    adding: 'Adding...',
    generatedImages: 'Customized Cards',
    mustBeLoggedIn: 'You must be logged in to view this content.',
    loading: 'Loading...',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    success: 'Success!',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    yes: 'Yes',
    no: 'No',
    add: 'Add',
    remove: 'Remove',
    update: 'Update',
    create: 'Create',
    view: 'View',
    details: 'Details',
    actions: 'Actions',
    settings: 'Settings',
    configuration: 'Configuration',
    apply: 'Apply',
    reset: 'Reset',
    clear: 'Clear',
    retry: 'Retry',
    done: 'Done',
    processing: 'Processing...',
    aiCustomization: 'AI Customization',
  },
  languages: {
    default: 'Default',
    any: 'Any',
    english: 'English',
    spanish: 'Spanish',
    french: 'French',
    german: 'German',
    italian: 'Italian',
    portuguese: 'Portuguese',
    japanese: 'Japanese',
    korean: 'Korean',
    russian: 'Russian',
    simplified_chinese: 'Simplified Chinese',
    traditional_chinese: 'Traditional Chinese',
    hebrew: 'Hebrew',
    latin: 'Latin',
    ancient_greek: 'Ancient Greek',
    arabic: 'Arabic',
    sanskrit: 'Sanskrit',
    phyrexian: 'Phyrexian',
    quenya: 'Quenya',
  },
  filters: {
    show: '✨ Show Pro Filters',
    hide: '✨ Hide Pro Filters',
  },
  search: {
    showing_start: 'Showing',
    showing_to: 'to',
    showing_of: 'of',
    showing_results: 'results',
    noResults: 'No results found.',
    useSearchTip: 'Use the search at the top of the page to look up a card.',
  },
  sort: {
    nameAsc: 'Name (A to Z)',
    nameDesc: 'Name (Z to A)',
    cmcAsc: 'Mana Value (Low to High)',
    cmcDesc: 'Mana Value (High to Low)',
    usdAsc: 'Price (Low to High)',
    usdDesc: 'Price (High to Low)',
    rarityAsc: 'Rarity (Common to Mythic)',
    rarityDesc: 'Rarity (Mythic to Common)',
    releasedDesc: 'Release Date (Newest First)',
    releasedAsc: 'Release Date (Oldest First)',
  },
  pages: {
    search: {
      heading: 'MTG Card Search',
    },
    sets: {
      heading: 'Card Sets',
      latestSets: 'Latest Sets',
      upcomingSets: 'Upcoming Sets',
      allSets: 'All Sets',
      noResults: 'No results found.',
    },
    set: {
      notFound: 'Set not found.',
      noCards: 'No cards found in this set.',
      addAll: 'Add {{count}} Cards to Proxy List',
      addedToList: 'Added {{count}} cards to Proxy List',
    },
    tokens: {
      heading: 'Tokens',
    },
    emblems: {
      heading: 'Emblems',
    },
    import: {
      heading: 'Import cards to Proxy List',
      description: 'Input the names of all the cards you want to add to the Proxy List.',
    },
    topProxies: {
      heading: 'Top Proxies',
      description: 'Here are the top 50 most popular MTG proxy cards on TCG Stacked.',
    },
    pokemon: {
      search: {
        heading: 'Pokemon Card Search',
      },
      sets: {
        heading: 'Pokemon Card Sets',
        latestSets: 'Latest Sets',
        upcomingSets: 'Upcoming Sets',
        allSets: 'All Sets',
      },
    },
  },
  theme: {
    light: 'Light',
    dark: 'Dark',
    toggle: 'Toggle theme',
  },
  cta: {
    title: 'Ready to dive in?',
    subtitle: 'Start proxying cards today.',
    searchByCard: 'Search by card',
    searchBySet: 'Search by set',
  },
  nav: {
    magicTheGathering: 'Magic: The Gathering',
    pokemon: 'Pokémon',
    sets: 'Sets',
    tokens: 'Tokens',
    emblems: 'Emblems',
    import: 'Import',
    topProxies: 'Top Proxies',
    customCards: 'Custom Cards',
    deckBuilder: 'Deck Builder',
    buildDeck: 'Build a Deck',
    publicDecks: 'Public Decks',
    favoriteDeck: 'My Favorite Decks',
    articles: 'Articles',
    feedback: 'Share Feedback',
    collection: 'My Collection',
    pokemonSets: 'Pokémon Sets',
    pokemonSearch: 'Search Pokémon Cards',
  },
  seo: {
    collection: {
      title: 'TCG Card Collection Manager | TCG Stacked',
      description: 'Efficiently manage, track, and value your trading card collection. Our comprehensive collection management system helps you organize Magic: The Gathering and Pokémon cards all in one secure platform.',
    },
    home: {
      title: 'Free Utilities for MTG & Pokémon | TCG Stacked',
      description: 'Access thousands of Magic: The Gathering and Pokémon cards for deck building, collection management, and proxy creation. The ultimate TCG companion for everyone from casual collectors to serious players.',
    },
    sets: {
      title: 'Magic: The Gathering Card Sets | TCG Stacked',
      description: 'Explore our comprehensive database of Magic: The Gathering sets from Alpha to the latest releases. Find high-resolution card images organized by expansion set for collectors, deck builders, and proxy creation.',
    },
    setDetail: {
      title: '{{setName}} Complete Card List | TCG Stacked',
      description:
        'Browse every card from {{setName}} in high resolution with detailed information. Build decks, discover synergies, and create quality proxies for playtesting. The definitive resource for Magic: The Gathering collectors and players.',
    },
    tokens: {
      title: 'MTG Token Library | TCG Stacked',
      description: 'Access our complete collection of Magic: The Gathering tokens - creatures, treasures, food, clues and more. High-resolution printable tokens to enhance your gameplay experience.',
    },
    emblems: {
      title: 'MTG Emblem Collection | TCG Stacked',
      description: 'Browse our comprehensive library of Magic: The Gathering emblems. High-quality printable planeswalker emblems to track powerful ongoing effects and enhance your gameplay experience.',
    },
    search: {
      title: 'Free MTG Utilities | TCG Stacked',
      description: 'Powerful search tools for Magic: The Gathering cards with advanced filtering by color, type, rarity, set, and more. Find exactly what you need for your collection, deck building, and game reference.',
    },
    pokemonHome: {
      title: 'Free Pokémon Utilities | TCG Stacked',
      description: 'Comprehensive Pokémon Trading Card Game resource with thousands of cards from every set. Build decks, manage your collection, and explore the entire Pokémon TCG universe in one place.',
    },
    pokemonSets: {
      title: 'Complete Pokémon TCG Set Database | TCG Stacked',
      description: 'Explore every Pokémon Trading Card Game set ever released. Browse cards by expansion, series, and release date with our comprehensive database designed for collectors, players, and deck builders.',
    },
    pokemonSetDetail: {
      title: '{{setName}} Pokémon Cards | TCG Stacked',
      description: 'View all cards from the {{setName}} Pokémon set with high-resolution images and detailed information. Perfect for collectors, deck builders, and players looking to enhance their gameplay experience.',
    },
    pokemonSearch: {
      title: 'Advanced Pokémon Card Search | TCG Stacked',
      description: 'Powerful search engine for Pokémon Trading Card Game with filtering by type, rarity, energy, HP, and more. Find exactly what you need for your collection, competitive deck building, or game reference.',
    },
    pokemonCard: {
      title: '{{cardName}} Pokémon Card | TCG Stacked',
      description: 'Detailed information for {{cardName}} from the {{setName}} expansion. View high-resolution images, card text, attack details, and add this card to your digital collection.',
    },
    support: {
      title: 'Customer Support Center | TCG Stacked',
      description: 'Get expert assistance with our trading card game platform. Our dedicated support team provides help with collection management, deck building, account settings, and technical issues to ensure the best possible experience.',
    },
    articles: {
      title: 'TCG Strategy Guides & Articles | TCG Stacked',
      description: 'In-depth articles, strategy guides, and tutorials from TCG experts. Learn about deck building, card synergies, tournament strategies, and gameplay techniques for Magic: The Gathering and Pokémon.',
    },
    import: {
      title: 'Bulk Card Import Tool | TCG Stacked',
      description: 'Powerful deck list import tool for Magic: The Gathering and Pokémon TCG. Convert lists from any format into digital collections or proxy lists instantly. Perfect for organizing your cards and playtesting competitive decks.',
    },
    topProxies: {
      title: 'Most Popular TCG Cards | TCG Stacked',
      description: 'Discover the most sought-after Magic: The Gathering and Pokémon cards based on real user data. Find inspiration for your next deck with our regularly updated list of trending cards in the TCG community.',
    },
    customCards: {
      title: 'Custom TCG Card Creator | TCG Stacked',
      description: 'Professional-grade custom card designer for Magic: The Gathering and Pokémon TCG. Create personalized cards with our intuitive editor featuring authentic templates and custom art options for creative expression.',
    },
    login: {
      title: 'Sign In | TCG Stacked',
      description: 'Log in to access your saved decks, collections, and personalized settings. Enjoy a seamless trading card game experience with your TCG Stacked account.',
    },
    register: {
      title: 'Create Free Account | TCG Stacked',
      description: 'Sign up for a free account to unlock powerful features including deck storage, collection tracking, and personalized recommendations. Join thousands of trading card game enthusiasts on TCG Stacked.',
    },
    termsOfService: {
      title: 'Terms of Service | TCG Stacked',
      description: 'Our comprehensive terms of service outline the guidelines for using TCG Stacked. Learn about our policies regarding proxy creation, account usage, and community standards.',
    },
    privacyPolicy: {
      title: 'Privacy Policy | TCG Stacked',
      description: 'Learn how we protect your personal information and data while using TCG Stacked. Our detailed privacy policy explains our commitment to security and transparency in all our operations.',
    },
    account: {
      title: 'Account Management | TCG Stacked',
      description: 'Manage your TCG Stacked profile, subscription settings, saved decks, and personal preferences.',
    },
    proMembership: {
      title: 'Pro Membership Benefits | TCG Stacked',
      description:
        'Elevate your trading card game experience with Pro Membership. Enjoy advanced features including ad-free browsing, unlimited deck storage, priority support, and exclusive customization options for Magic: The Gathering and Pokémon TCG.',
    },
    deckBuilder: {
      title: 'Advanced TCG Deck Builder | TCG Stacked',
      description: 'Build powerful, optimized decks with our professional-grade deck builder. Access advanced analytics, mana curve visualization, and proxy creation for playtesting Magic: The Gathering and Pokémon TCG decks.',
    },
    deckEditor: {
      title: 'Precision Deck Editor | TCG Stacked',
      description: 'Fine-tune your trading card game decks with our comprehensive editor. Optimize mana curves, adjust card ratios, manage sideboards, and test variations to perfect your strategy for competitive gameplay.',
    },
    publicDecks: {
      title: 'Community Deck Database | TCG Stacked',
      description: 'Explore winning strategies and innovative deck ideas from the trading card game community. Browse decks by format, theme, and popularity, then create proxies to playtest them before investing in cards.',
    },
  },
  pro: {
    pricing: {
      title: 'Level Up Your Stack',
      subtitle: 'Go Pro and unlock a premium, ad-free experience with exclusive features, that take your proxies to the next level!',
      monthlyPlan: 'Monthly Pro Membership',
      yearlyPlan: 'Yearly Pro Membership',
      monthlyPrice: '$5.00 per month',
      yearlyPrice: '$40.00 per year',
      subscribeMonthly: 'Get Started Now',
      subscribeYearly: 'Save Big Yearly',
      signInToSubscribe: 'Sign in to Unlock Pro',
      manageSubscription: 'Manage Your Pro Benefits',
      nextBillingDate: 'Your next payment date',
      benefitsEndDate: 'Pro access until',
      viewInvoice: 'View Receipt',
      changePlan: 'Switch Your Plan',
      reactivate: 'Restore Pro Benefits',
      active: 'Active',
      cancelled: 'Cancelled',
      freeTrial: 'Free Trial',
      freeTrialEnds: 'Free Trial Ends',
      startFreeTrial: 'Start 7-Day Free Trial',
      signInForFreeTrial: 'Sign in for Free 7-Day Trial',
      subscribe: 'Subscribe Now',
      current: 'Current',
    },
    benefits: {
      title: 'Why Go Pro with TCG Stacked?',
      subtitle: "Join hundreds of players who've enhanced their trading card game experience with these exclusive Pro features!",
      noAds: {
        title: 'Clean, Ad-Free Experience',
        description: 'Say goodbye to interruptions! Enjoy a pristine interface without ads, banners, or pop-ups. Pure trading card game utility goodness.',
      },
      darkMode: {
        title: 'Epic Dark Mode',
        description: 'Easy on the eyes and looking sleek! Perfect for night owls and marathon gaming sessions in any lighting condition.',
      },
      advancedSearch: {
        title: 'Pro-Level Search Magic',
        description: 'Find exactly what you need with powerful filters! Filter by color, type, rarity, and more to build the perfect MTG or Pokémon deck.',
      },
      multipleDecks: {
        title: 'Unlimited Deck Building',
        description: "Deck builder's paradise! Create and save as many MTG and Pokémon decks as you want – from casual fun to competitive powerhouses.",
      },
      futureFeatures: {
        title: 'First Access to New Features',
        description: "Be at the cutting edge! Pro members always get first dibs on exciting new features as soon as they're released.",
      },
      cancelAnytime: {
        title: 'Zero Risk, All Reward',
        description: 'Complete freedom! No long-term contracts or hidden fees. Cancel with a single click whenever you want.',
      },
      prioritySupport: {
        title: 'VIP Support Access',
        description: 'Skip the line! Your questions and concerns get priority treatment with our dedicated support team.',
      },
    },
    features: {
      unlimitedDecks: 'Unlimited MTG & Pokémon deck creation',
      noAds: 'No advertisements',
      prioritySupport: 'VIP support access',
      darkMode: 'Sleek dark mode interface',
      advancedSearch: 'Pro search filters across all TCGs',
      aiCustomization: '5 monthly AI Generation Credits',
      futureFeatures: 'Exclusive upcoming features',
      cancelAnytime: 'Hassle-free cancellation',
    },
    promotion: {
      title: 'Unleash Unlimited Deck Creation Potential',
      description: 'Break free from limitations! Upgrade to Pro now and build as many MTG and Pokémon decks as your imagination allows.',
      customizeTitle: 'Customize with AI',
      customizeDescription: 'Upgrade to Pro and create up to 5 custom card variations monthly for Magic: the Gathering proxies!',
      banner: 'Try Pro free for 7 days! No ads, AI card customizations, unlimited decks, and more.',
      tryNow: 'Try Now',
    },
    account: {
      title: 'Your Pro Membership',
      description: 'Manage your premium benefits',
      subscribeToPro: 'Upgrade to Pro Now',
    },
  },
  auth: {
    signIn: {
      title: 'Sign in to your account',
      withGoogle: 'Continue with Google',
      withEmail: 'Or continue with',
      sendMagicLink: 'Send Magic Link',
      noAccount: "Don't have an account?",
      checkEmail: 'Check your email for a link to sign in',
      errors: {
        failed: 'Failed to sign in',
        failedGoogle: 'Failed to sign in with Google',
        failedEmail: 'Failed to sign in with email',
        noEmail: 'No email found',
      },
      terms: 'By logging in, I confirm that I have read and agree to the',
    },
    register: {
      title: 'Create your account',
      haveAccount: 'Already have an account?',
      terms: 'By creating an account, I confirm that I have read and agree to the',
    },
    common: {
      termsOfService: 'Terms of Service',
      privacyPolicy: 'Privacy Policy',
      and: 'and',
    },
  },
  home: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Creatures', 'Commanders', 'Tokens', 'Emblems', 'Planeswalkers', 'Lands', 'Artifacts', 'Enchantments', 'Instants'],
      description: 'From Black Lotus to the latest mythics, your dream deck is within reach, regardless of cost.',
      search: {
        cards: {
          tab: 'Cards',
          placeholder: 'Search for any MTG card...',
          error: 'Failed to fetch random cards',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Search for any MTG card set...',
        },
        tokens: {
          tab: 'Tokens',
          placeholder: 'Search for any MTG card token...',
        },
        button: 'Search',
        hint: {
          cards: 'Press Enter or click Search to find your cards',
          sets: 'Press Enter or click Search to find your sets',
          tokens: 'Press Enter or click Search to find your tokens',
        },
        aria: {
          searchIcon: 'Search icon',
          searchInput: {
            cards: 'Search for cards',
            sets: 'Search for sets',
            tokens: 'Search for tokens',
          },
        },
      },
      images: {
        cardAlt: 'Trading card image',
      },
      processedCount: "🎉 We've processed {{count}} free proxies for the community! 🎉",
    },
    features: {
      section1: {
        badge: 'Print Proxies',
        title: 'Print MTG Proxy Cards',
        subtitle: 'Add cards to your Proxy List, print them out, and use them in your decks today!',
        features: [
          {
            name: 'Add card to your Proxy List',
            description: 'Search for any card using the Search page or browse by set and add the cards you want to your Proxy List.',
          },
          {
            name: 'Print your cards',
            description: 'Once you have added all the cards you want to your Proxy List, you can print them out and use them in your decks.',
          },
          {
            name: 'Use them in your decks',
            description: 'Once you have printed out your cards, you can use them in your decks. Cut them out and tape them to a basic land or use a sleeve with a basic land inside.',
          },
        ],
        images: {
          cartScreenshot: 'Cart screenshot showing how to add cards to your Proxy List',
        },
      },
      section2: {
        badge: 'Deck Builder',
        title: 'Build and manage Magic: The Gathering Decks',
        subtitle: 'Create and manage your own decks, or browse public decks created by the community.',
        features: [
          {
            name: 'Manage your MTG Decks',
            description: 'All users can create and manage one MTG deck. Pro members can create an unlimited number of decks.',
          },
          {
            name: 'Print your cards',
            description: 'Once you have added all the cards you want to your deck, you can add them to your Proxy List all at once.',
          },
          {
            name: 'Browse Public Decks',
            description: 'Add entire decks made by the community to your Proxy List so you can easily play test new decks.',
          },
        ],
        images: {
          deckBuilderScreenshot: 'Deck Builder interface showing how to manage your decks',
        },
      },
    },
  },
  footer: {
    copyright: 'TCG Stacked, All rights reserved.',
    disclaimer: 'TCG Stacked is not produced, endorsed, supported, or affiliated with any trading card game publisher.',
    affiliate: 'As a TCGplayer affiliate partner, TCG Stacked may earn a commission on qualifying purchases.',
    builtBy: 'Built by',
    minnerLabs: 'Minner Labs',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    support: 'Support',
    articles: 'Articles & Guides',
  },
  advancedFilters: {
    colors: 'Colors',
    colorIdentity: 'Color Identity',
    exact: 'Exact',
    atLeast: 'At Least',
    atMost: 'At Most',
    rarities: 'Rarities',
    types: 'Types',
    format: 'Format',
    manaValue: 'Mana Value',
    cardName: 'Card Name',
    cardText: 'Card Text',
    specialCharacteristics: 'Special Characteristics',
    loading: 'Loading...',
    searchCardName: 'Search card name...',
    searchCardText: 'Search card text...',
    namePrefix: 'Name: ',
    manaPrefix: 'Mana: ',
    textPrefix: 'Text: ',
    removeFromFilter: '✕',
    selectLanguage: 'Select language',
    showFilters: '✨ Show Pro Filters',
    hideFilters: '✨ Hide Pro Filters',
    hpRange: 'HP Range',
    typePrefix: 'Type: ',
    rarityPrefix: 'Rarity: ',
    formatPrefix: 'Format: ',
    specialPrefix: 'Special: ',
    supertypes: 'Supertypes',
    subtypes: 'Subtypes',
    legalities: 'Legalities',
    enterCardName: 'Enter card name...',
    enterCardText: 'Enter card text...',
    selectTypes: 'Select types...',
    selectRarities: 'Select rarities...',
    selectSupertypes: 'Select supertypes...',
    selectSubtypes: 'Select subtypes...',
    selectLegalities: 'Select legalities...',
    clearAll: 'Clear All',
    applyFilters: 'Apply Filters',
    activeFilters: 'Active Filters',
    title: 'Advanced Filters',
    hpRange: 'HP Range',
    cardTypes: 'Card Types',
    isFullArt: 'Full Art',
    isExtendedArt: 'Extended Art',
    isModal: 'Modal',
    isShowcase: 'Showcase',
    isRainbowRare: 'Rainbow Rare',
    isSecretRare: 'Secret Rare',
    isPromo: 'Promo',
    isAlternateArt: 'Alternate Art',
    rarity: 'Rarity',
  },
  card: {
    addToPrintList: 'Add to Proxy List',
    removeFromPrintList: 'Remove from Proxy List',
    cardsInPrintList: 'card in Proxy List',
    cardsInPrintListPlural: 'cards in Proxy List',
    buyOn: 'Buy on TCGplayer',
    buyFor: 'Buy for ',
    viewDetails: 'View Details',
    type: 'Type',
    manaCost: 'Mana Cost',
    rarity: 'Rarity',
    artist: 'Artist',
    collectorNumber: 'Collector Number',
    oracleText: 'Oracle Text',
    youMightAlsoLike: 'You might also like...',
    noRecommendations: 'No recommendations available at this moment.',
    details: 'Details',
    rulings: 'Rulings',
    legality: 'Legality',
    share: 'Share',
    favorite: 'Favorite',
    noRulings: 'No rulings available for this card.',
    noLegalityInfo: 'No legality information available for this card.',
    published: 'Published',
    legal: 'Legal',
    restricted: 'Restricted',
    banned: 'Banned',
    format: 'Format',
    status: 'Status',
    viewMore: 'View More',
    viewLess: 'View Less',
    customizeWithAI: 'Customize with AI',
    otherVersions: 'Unique Prints',
    showUniqueVersions: 'Show Unique Prints',
    hideUniqueVersions: 'Hide Unique Prints',
  },
  cart: {
    title: 'Proxy List',
    closePanel: 'Close panel',
    empty: 'No proxies in the Proxy List.',
    emptyMtg: 'No Magic: The Gathering cards in the Proxy List.',
    emptyPokemon: 'No Pokémon cards in the Proxy List.',
    addOutsidePadding: 'Add outside padding',
    addPaddingBetweenCards: 'Add padding between cards',
    paperSize: 'Paper size',
    paperSizeA4: 'A4',
    paperSizeLetter: 'Letter',
    paperSizeLegal: 'Legal',
    scale: 'Scale',
    scale90: '90%',
    scale100: '100%',
    scale110: '110%',
    clearCardList: 'Clear card list',
    print: 'Print',
    success: 'Success!',
    mtgTabLabel: 'Magic: The Gathering',
    pokemonTabLabel: 'Pokemon',
    mtgCardSettings: 'MTG Card Settings',
    pokemonCardSettings: 'Pokemon Card Settings',
    configMtgCards: 'Configure settings for printing Magic: The Gathering cards',
    configPokemonCards: 'Configure settings for printing Pokemon cards',
  },
  setsList: {
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    searchPlaceholder: 'Search...',
  },
  customizeCardModal: {
    title: 'Customize Card with AI',
    description: 'Describe how you want to customize this card. AI will generate a new version while keeping the card frame and structure intact.',
    buttonText: 'Customize with AI',
    placeholder: 'Describe your custom card variation...',
    generateButton: 'Customize with AI',
    generatingButton: 'Customizing...',
    generationWaitMessage: 'This process may take a minute or two. Thanks for your patience!',
    addToPrintListButton: 'Add to Proxy List',
    successMessage: 'Added custom card to Proxy List',
    cancelledGeneration: 'Card generation cancelled',
    remainingGenerationsOne: '{{count}} credit left',
    remainingGenerationsOther: '{{count}} credits left',
    promptIdeas: 'Quick Prompt Ideas',
    noCreditsWarning: 'No credits available',
    lowCreditsWarning: 'Low credits remaining',
    buyCredits: 'Buy Credits',
    prompts: {
      fantasy: 'Transform this card into a high fantasy style with magical elements, glowing runes, and ethereal lighting. Keep the card frame intact but make the artwork look like it belongs in a medieval fantasy world.',
      fantasyShort: 'Fantasy',
      scifi: 'Reimagine this card with a futuristic sci-fi aesthetic. Add cybernetic elements, holographic displays, and a neon-lit dystopian background while maintaining the original card structure.',
      scifiShort: 'Sci-Fi',
      horror: 'Give this card a dark, horror-themed makeover with eerie lighting, unsettling elements, and a creepy atmosphere. Maintain the card frame but make the artwork feel like it belongs in a horror setting.',
      horrorShort: 'Horror',
      anime: 'Redesign this card in a vibrant anime art style with bold colors, dynamic poses, and expressive features. Keep the card structure intact but transform the artwork into anime-inspired illustration.',
      animeShort: 'Anime',
      realistic: 'Make this card look photorealistic with detailed textures, natural lighting, and lifelike elements. Maintain the card frame but transform the artwork into a hyper-realistic illustration.',
      realisticShort: 'Realistic',
      watercolor: 'Transform this card into a delicate watercolor painting with soft, flowing colors, gentle brush strokes, and translucent effects. Keep the card frame intact but give the artwork a hand-painted watercolor appearance.',
      watercolorShort: 'Watercolor',
      pixelart: 'Recreate this card in a retro pixel art style reminiscent of classic video games. Use blocky pixels, limited color palette, and simplified forms while maintaining the card frame and overall structure.',
      pixelartShort: 'Pixel Art',
      oilpainting: 'Reimagine this card as a classical oil painting with rich textures, dramatic lighting, and visible brushstrokes. Keep the card frame intact but transform the artwork to resemble a museum-quality oil painting.',
      oilpaintingShort: 'Oil Painting',
      seasonal: 'Give this card a seasonal makeover with elements of the current season. Add autumn leaves, winter snow, spring flowers, or summer sunshine depending on the current time of year.',
      seasonalShort: 'Seasonal',
      steampunk: 'Reimagine this card with a steampunk aesthetic featuring brass gears, steam-powered machinery, Victorian fashion elements, and an industrial revolution vibe.',
      steampunkShort: 'Steampunk',
      chibi: 'Transform this card into an adorable chibi style with cute, small characters with oversized heads and simplified features for a charming, playful look.',
      chibiShort: 'Chibi Style',
      cyberpunk: 'Reimagine this card with a cyberpunk aesthetic featuring neon lights, high-tech elements, urban dystopia, and futuristic technology integrated with human elements.',
      cyberpunkShort: 'Cyberpunk',
      append: 'Make sure to maintain the card frame, text boxes, and overall structure. Only modify the artwork.',
    },
    error: {
      failed: 'Failed to generate custom card',
    },
  },
  generatedImages: {
    title: 'Customized Cards',
    description: 'View and manage your AI-generated card images',
    noImages: "You haven't generated any custom card images yet.",
    error: 'Failed to load your generated images.',
    addToPrintList: 'Add to Proxy List',
    addedToCart: 'Added to Proxy List',
    errorAddingToCart: 'Failed to add to Proxy List',
  },
  collection: {
    title: 'My Collection',
    loginRequired: 'Login Required',
    loginMessage: 'Please log in to view your collection',
    emptyCollection: 'No Cards Found',
    emptyCollectionMessage: 'Your collection is empty. Add cards from the card detail page or use the Bulk Add feature.',
    noMatchingCards: 'No cards match your filters.',
    searchPlaceholder: 'Search cards...',
    sortBy: 'Sort by',
    sortName: 'Name',
    sortPrice: 'Price',
    sortDate: 'Date Added',
    sortQuantity: 'Quantity',
    filterRarity: 'Rarity',
    filterSet: 'Set',
    allRarities: 'All Rarities',
    allSets: 'All Sets',
    filters: 'Filters',
    clearFilters: 'Clear Filters',
    sortAscending: 'Sort Ascending',
    sortDescending: 'Sort Descending',
    bulkAdd: 'Bulk Add',
    bulkAddTitle: 'Add Cards from Proxy List',
    bulkAddDescription: 'Add all cards from your Proxy List to your collection.',
    bulkAddCount: '{{count}} cards will be added to your collection.',
    emptyCart: 'Your Proxy List is empty',
    bulkAddSuccess: 'Cards added to collection',
    bulkAddError: 'Failed to add cards to collection',
    addToCollection: 'Add to Collection',
    addToCart: 'Add to Proxy List',
    addMore: 'Add More',
    inCollection: 'In Collection',
    quickAdd: 'Quick Add',
    searchCards: 'Search cards...',
    typeToSearch: 'Type at least 3 characters to search',
    noResults: 'No results found',
    noCardSelected: 'No card selected',
    addCardToCollection: 'Add Card to Collection',
    addCardDescription: 'Specify the quantity to add to your collection.',
    quantity: 'Quantity',
    price: 'Price',
    addedToCart: 'Collection added to Proxy List',
    stats: 'Collection Stats',
    totalValue: 'Total Value',
    filteredValue: 'Filtered Value',
    cardCount: 'Card Count',
    totalCards: 'total cards',
    uniqueCards: 'unique cards',
    filteredCards: 'filtered cards',
    rarityBreakdown: 'Rarity Breakdown',
    // Export feature
    export: 'Export Collection',
    exporting: 'Exporting...',
    exportSuccess: 'Collection exported successfully',
    exportError: 'Failed to export collection',
    noCardsToExport: 'No cards to export',
    exportCardName: 'Card Name',
    exportSet: 'Set',
    exportRarity: 'Rarity',
    exportQuantity: 'Quantity',
    exportPrice: 'Price',
    exportTotalValue: 'Total Value',
    exportDateAdded: 'Date Added',
    // Quick add feature
    quickAdd: 'Quick Add',
    searchCards: 'Search for cards to add',
    typeToSearch: 'Type at least 3 characters to search',
    noResults: 'No results found',
    noCardSelected: 'No card selected',
    addCardToCollection: 'Add Card to Collection',
    addCardDescription: 'Specify the quantity to add to your collection',
    quantity: 'Quantity',
    price: 'Price',
    // Insights
    insights: 'Collection Insights',
    noInsightsAvailable: 'No insights available for your collection',
    insightsDescription: 'Detailed statistics about your collection',
    rarityDistribution: 'Rarities',
    topSets: 'Top Sets',
    priceDistribution: 'Prices',
    // Clear collection feature
    clearCollection: 'Clear Collection',
    clearCategory: 'Clear {{category}}',
    clearCollectionConfirmTitle: 'Clear Collection?',
    clearCollectionConfirmMessage: 'This action cannot be undone. All cards in your collection will be permanently removed.',
    clearCategoryConfirmMessage: 'This action cannot be undone. All {{category}} cards in your collection will be permanently removed.',
    clearedCategory: '{{category}} cards cleared from collection',
    // Edit card in collection
    editCardInCollection: 'Edit Card in Collection',
    editCardDescription: 'Update the details of this card in your collection.',
    viewCardDetails: 'View Card Details',
    condition: 'Condition',
    selectCondition: 'Select condition',
    language: 'Language',
    selectLanguage: 'Select language',
    finish: 'Finish',
    selectFinish: 'Select finish',
    purchasePrice: 'Purchase Price',
    isProxy: 'This is a proxy',
    saveChanges: 'Save Changes',
    removeCard: 'Remove Card',
    cardRemoved: 'Card removed from collection',
    errorRemovingCard: 'Error removing card from collection',
    errorSavingChanges: 'Error saving changes to card',
    // Landing page
    landing: {
      title: 'Manage Your MTG Collection',
      description: 'Keep track of all your Magic: The Gathering cards in one place with our powerful collection management tools.',
      intro: 'Our collection management system allows you to easily track, organize, and value your entire Magic: The Gathering card collection. Create an account today to get started!',
      createAccount: 'Create Account',
      getStarted: 'Get Started Now',
      howItWorks: 'How It Works',
      step1: 'Create a free account to access your personal collection',
      step2: 'Add cards to your collection manually or import them from a CSV file',
      step3: 'Organize your cards by set, color, rarity, and more',
      step4: 'Track the value of your collection over time',
      step5: 'Export your collection data whenever you need it',
    },
    features: {
      track: {
        title: 'Track Your Cards',
        description: 'Keep a detailed inventory of all your Magic: The Gathering cards in one place',
      },
      organize: {
        title: 'Organize by Set',
        description: 'Sort and filter your collection by set, rarity, color, and more',
      },
      value: {
        title: 'Track Value',
        description: 'See the current market value of your entire collection at a glance',
      },
      export: {
        title: 'Export Data',
        description: 'Export your collection data for use in other applications',
      },
    },
  },
  // Main landing page translations
  landing: {
    hero: {
      title: 'Your Ultimate TCG Companion',
      description: 'Search, browse, and create proxies for your favorite trading card games. Manage your collection and build your dream deck today!',
      mtgButton: 'Magic: The Gathering',
      pokemonButton: 'Pokémon',
      stats: {
        mtgProxies: '50,000+ MTG proxies created',
        pokemonCards: '10,000+ Pokémon cards available',
        comingSoon: 'New TCGs coming soon',
      },
    },
    tcgSections: {
      title: 'Explore Trading Card Games',
      mtg: {
        badge: 'Magic: The Gathering',
        title: 'The Original Trading Card Game',
        description: 'Explore the multiverse with thousands of unique cards',
        exploreButton: 'Explore',
        features: {
          search: {
            title: 'Search Cards',
            description: 'Find any MTG card by name, type, or text',
          },
          sets: {
            title: 'Browse Sets',
            description: 'Explore cards by expansion set',
          },
          collection: {
            title: 'My Collection',
            description: 'Track and manage your MTG cards',
          },
          tokens: {
            title: 'Tokens & Emblems',
            description: 'Access tokens and emblems for your games',
          },
        },
      },
      pokemon: {
        badge: 'Pokémon',
        title: "Gotta Catch 'Em All",
        description: 'Build your deck with your favorite Pokémon',
        exploreButton: 'Explore',
        features: {
          search: {
            title: 'Search Cards',
            description: 'Find any Pokémon card by name or type',
          },
          sets: {
            title: 'Browse Sets',
            description: 'Explore cards from Base Set to latest expansions',
          },
          collection: {
            title: 'My Collection',
            description: 'Track and manage your Pokémon cards',
          },
          comingSoon: {
            title: 'Coming Soon',
            description: 'More Pokémon features in development',
          },
        },
      },
    },
    crossTcgFeatures: {
      badge: 'Cross-TCG Features',
      title: 'One Platform for All Your TCGs',
      description: 'TCG Stacked brings together multiple trading card games in one unified platform, making it easy to manage your entire collection.',
      features: {
        unifiedSearch: {
          title: 'Unified Search',
          description: "Search across all supported TCGs with powerful filters to find exactly what you're looking for. Filter by name, type, set, and more.",
          mtgLink: 'MTG Search',
          pokemonLink: 'Pokémon Search',
        },
        collectionManagement: {
          title: 'Collection Management',
          description: 'Track your entire card collection across multiple TCGs. Organize by game, set, and type. Monitor the value of your collection over time.',
          link: 'Manage Collection',
        },
        deckBuilding: {
          title: 'Deck Building & Analysis',
          description: 'Build and analyze decks for your favorite TCGs. Get insights into mana curves, card type distribution, and more to optimize your gameplay.',
          mtgLink: 'MTG Decks',
          pokemonComingSoon: 'Pokémon Decks (Coming Soon)',
        },
      },
    },
    platformFeatures: {
      title: 'Platform Features',
      advancedSearch: {
        title: 'Advanced Search',
        description: "Find exactly what you're looking for with powerful search filters across all supported TCGs.",
      },
      collectionManagement: {
        title: 'Collection Management',
        description: 'Track your card collection, organize by TCG, and manage your inventory all in one place.',
      },
      proxyCreation: {
        title: 'Proxy Creation',
        description: 'Create high-quality proxies for casual play and deck testing without breaking the bank.',
      },
    },
  },
  // Pokemon page translations
  pokemon: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Pokémon', 'Trainers', 'Energies'],
      description: 'Search, browse, and create proxies of any Pokémon card.',
      search: {
        cards: {
          tab: 'Cards',
          placeholder: 'Search for any Pokemon card...',
          error: 'Failed to fetch random Pokemon cards',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Search for any Pokemon card set...',
        },
        button: 'Search',
        hint: {
          cards: 'Press Enter or click Search to find your cards',
          sets: 'Press Enter or click Search to find your sets',
        },
        aria: {
          searchIcon: 'Search icon',
          searchInput: {
            cards: 'Search for Pokemon cards',
            sets: 'Search for Pokemon sets',
          },
        },
      },
      images: {
        cardAlt: 'Pokemon card image',
      },
      processedCount: 'Explore over {{count}} Pokemon cards in our database!',
    },
    features: {
      section1: {
        badge: 'Print Proxies',
        title: 'Print Pokemon Proxy Cards',
        subtitle: 'Add cards to your Proxy List, print them out, and use them in your decks today!',
        features: [
          {
            name: 'Add Pokemon cards to your Proxy List',
            description: 'Search for any Pokemon card using the Search page or browse by set and add the cards you want to your Proxy List.',
          },
          {
            name: 'Print your Pokemon cards',
            description: 'Once you have added all the cards you want to your Proxy List, you can print them out and use them in your decks.',
          },
          {
            name: 'Use them in your decks',
            description: 'Once you have printed out your cards, you can use them in your decks for casual play and testing.',
          },
        ],
        images: {
          cardsScreenshot: 'Pokemon cards screenshot showing various Pokemon cards',
        },
      },
      section2: {
        badge: 'Advanced Search',
        title: 'Find any Pokemon card with powerful search tools',
        subtitle: "Our advanced search tools make it easy to find exactly the Pokemon cards you're looking for.",
        features: [
          {
            name: 'Browse by set',
            description: 'Explore Pokemon cards organized by set, from Base Set to the latest expansions.',
          },
          {
            name: 'Search by type',
            description: 'Find Pokemon cards by type, including Fire, Water, Grass, and more.',
          },
          {
            name: 'Filter by rarity',
            description: 'Filter Pokemon cards by rarity, from Common to Ultra Rare and Secret Rare.',
          },
        ],
        images: {
          searchScreenshot: 'Pokemon search interface showing search filters and results',
        },
      },
      section3: {
        badge: 'Collection Management',
        title: 'Manage Your Pokemon Collection',
        subtitle: 'Keep track of all your Pokemon Trading Card Game cards in one place with our powerful collection management tools.',
        features: [
          {
            name: 'Track Your Pokemon Cards',
            description: 'Keep a detailed inventory of all your Pokemon Trading Card Game cards in one place',
          },
          {
            name: 'Organize by Set',
            description: 'Sort and filter your collection by set, rarity, type, and more',
          },
          {
            name: 'Track Value',
            description: 'See the current market value of your entire Pokemon card collection at a glance',
          },
        ],
        images: {
          collectionScreenshot: 'Pokemon collection management interface showing organized cards',
        },
      },
    },
    cta: {
      title: 'Ready to get started?',
      subtitle: 'Start proxying Pokemon cards today.',
      searchByCard: 'Search by card',
      searchBySet: 'Search by set',
    },
    search: {
      title: 'Pokemon Card Search',
      noResults: 'No Pokemon cards found matching your search.',
      tryAdjusting: "Try adjusting your search to find what you're looking for.",
    },
    sets: {
      title: 'Pokemon Card Sets',
      latestSets: 'Latest Sets',
      upcomingSets: 'Upcoming Sets',
      allSets: 'All Sets',
      noResults: 'No Pokemon sets found.',
      searchPlaceholder: 'Search sets...',
      sortBy: {
        nameAsc: 'Name (A to Z)',
        nameDesc: 'Name (Z to A)',
        releaseDateDesc: 'Release Date (Newest First)',
        releaseDateAsc: 'Release Date (Oldest First)',
      },
      filterBy: 'Filter by series',
      allSeries: 'All Series',
    },
    set: {
      notFound: 'Pokemon set not found.',
      backToSets: 'Back to Sets',
      cards: 'cards',
      released: 'Released',
      noCards: 'No cards found in this set.',
      tryAdjusting: "Try adjusting your search to find what you're looking for.",
      sortBy: 'Sort by',
      filterBy: 'Filter by',
      allTypes: 'All Types',
      allRarities: 'All Rarities',
      searchPlaceholder: 'Search cards in this set...',
    },
    card: {
      notFound: 'Pokemon card not found.',
      backToSearch: 'Back to Search',
      addToPrintList: 'Add to Proxy List',
      removeFromPrintList: 'Remove from Proxy List',
      inPrintList: 'In Proxy List',
      buyOn: 'Buy on TCGplayer',
      details: 'Details',
      type: 'Type',
      rarity: 'Rarity',
      set: 'Set',
      artist: 'Artist',
      number: 'Card Number',
      flavorText: 'Flavor Text',
      attacks: 'Attacks',
      abilities: 'Abilities',
      weakness: 'Weakness',
      resistance: 'Resistance',
      retreatCost: 'Retreat Cost',
      legality: 'Legality',
      otherVersions: 'Other Versions',
      youMightAlsoLike: 'You might also like...',
    },
  },
  // Add more translation keys as needed
  feedback: {
    buttonLabel: 'Feedback',
    title: 'Share Your Feedback',
    description: 'We value your input to improve TCG Stacked. Please share your thoughts with us.',
    categoryLabel: 'Category',
    categories: {
      bug: 'Bug Report',
      feature: 'Feature Request',
      improvement: 'Improvement Suggestion',
      general: 'General Feedback',
      other: 'Other',
    },
    messageLabel: 'Your Feedback',
    messagePlaceholder: 'Please share your thoughts, suggestions, or report an issue...',
    ratingLabel: 'Rate Your Experience (Optional)',
    emailLabel: 'Email (Optional)',
    emailPlaceholder: 'your@email.com',
    emailHelp: "Provide your email if you'd like us to follow up with you.",
    submitting: 'Submitting...',
    submitButton: 'Submit Feedback',
    successMessage: 'Thank you for your feedback!',
    errorMessage: 'Failed to submit feedback. Please try again.',
  },
  // New translations for combined hero component
  hero: {
    game: {
      pokemon: {
        tab: 'Pokemon',
      },
      mtg: {
        tab: 'Magic: The Gathering',
      },
    },
    search: {
      cards: {
        placeholder: 'Search for any card...',
      },
      sets: {
        placeholder: 'Search for any card set...',
      },
      button: 'Search',
      hint: {
        cards: 'Press Enter or click Search to find your cards',
        sets: 'Press Enter or click Search to find your sets',
      },
      aria: {
        searchIcon: 'Search icon',
        searchInput: {
          cards: 'Search for cards',
          sets: 'Search for sets',
        },
      },
    },
  },
  // MTG specific translations
  mtg: {
    hero: {
      title: 'Proxy',
      rotatingWords: ['Creatures', 'Commanders', 'Lands', 'Artifacts', 'Enchantments', 'Planeswalkers'],
      description: 'Search, browse, and create proxies for Magic: The Gathering cards.',
      search: {
        cards: {
          tab: 'Cards',
          placeholder: 'Search for any MTG card...',
          error: 'Failed to fetch random MTG cards',
        },
        sets: {
          tab: 'Sets',
          placeholder: 'Search for any MTG card set...',
        },
        button: 'Search',
        hint: {
          cards: 'Press Enter or click Search to find your cards',
          sets: 'Press Enter or click Search to find your sets',
        },
        aria: {
          searchIcon: 'Search icon',
          searchInput: {
            cards: 'Search for Magic cards',
            sets: 'Search for Magic sets',
          },
        },
      },
      images: {
        cardAlt: 'Magic card image',
      },
      processedCount: 'Explore over {{count}} Magic: The Gathering cards in our database!',
    },
  },

  // Credit Purchase Modal translations
  creditPurchaseModal: {
    title: 'Purchase AI Generation Credits',
    description: 'Purchase additional AI generation credits to customize more cards.',
    buttonText: 'Buy Credits',
    currentCredits: 'Current Credits',
    selectPackage: 'Select Credit Package',
    purchase: 'Purchase Now',
    noCreditsWarning: 'No credits available',
    lowCreditsWarning: 'Low credits remaining',
    buyCredits: 'Buy Credits',
    remainingGenerationsOne: '{{count}} Credit',
    remainingGenerationsOther: '{{count}} Credits',
    creditPackages: {
      small: 'Small',
      medium: 'Medium',
      large: 'Large',
    },
    loadingCredits: 'Loading credit information...',
    valuePerCredit: '${value}/credit',
    credits: 'Credits',
    failedCheckout: 'Failed to create checkout session',
  },

  // New AI page translations
  ai: {
    pageTitle: 'Customize Your Proxy Cards with AI Magic | TCG Stacked',
    pageDescription: 'Transform your Magic: The Gathering cards with AI-powered custom artwork. Exclusive to Pro members.',
    hero: {
      badge: 'Pro Member Exclusive',
      title: 'Customize Your Proxy Cards with AI Magic',
      subtitle: 'As a Pro Member, you can create custom artwork for your Magic: The Gathering proxies in seconds',
      cta: 'Try Pro Membership Free',
    },
    features: {
      title: 'Powerful AI Features at Your Fingertips',
      subtitle: 'Our AI-powered customization gives you complete creative control over your Magic: The Gathering proxy cards',
      cardIntegrity: {
        title: 'Preserve Card Integrity',
        description: 'Our AI only modifies the artwork while maintaining the card frame, text, mana symbols, and layout perfectly intact.',
      },
      creativity: {
        title: 'Unlimited Creativity',
        description: 'Transform your cards with any theme or style you can imagine - from fantasy to sci-fi, photorealistic to abstract.',
      },
      instantResults: {
        title: 'Instant Results',
        description: 'Generate custom artwork in seconds with no design skills needed. Simply describe what you want to see.',
      },
      saveCreations: {
        title: 'Save Your Creations',
        description: 'All your AI-generated cards are saved to your account so you can access them anytime from your dashboard.',
      },
      printAnytime: {
        title: 'Print Anytime',
        description: 'Add your custom cards to your proxy list whenever you want and print them with the rest of your collection.',
      },
    },
    credits: {
      title: 'AI Generation Credits',
      subtitle: 'Customize and transform your Magic: The Gathering proxy cards with powerful, affordable, and easy-to-use AI generation credits.',
      howItWorks: 'How Credits Work',
      step1: {
        number: '1',
        title: 'Purchase credits',
        description: 'in bundles that fit your creativity needs and budget',
      },
      step2: {
        number: '2',
        title: 'Generate custom artwork',
        description: 'for any Magic: The Gathering proxy card using 1 credit per generation',
      },
      step3: {
        number: '3',
        title: 'Keep track of your usage',
        description: 'in your account dashboard and purchase more anytime',
      },
      proAdvantage: {
        title: 'Pro Member Advantage',
        description: 'Pro Members receive 5 monthly AI Generation Credits as part of their subscription. Join Pro to maximize your creative potential!',
      },
      purchaseButton: 'Purchase Credits Now',
      unlockProButton: 'Unlock Pro Membership',
      packages: {
        title: 'Credit Packages',
        small: {
          name: 'Small',
          credits: '5',
          price: '2.99',
          value: '$0.60/credit',
        },
        medium: {
          name: 'Medium',
          credits: '15',
          price: '7.99',
          value: '$0.53/credit',
          popular: 'Popular',
        },
        large: {
          name: 'Large',
          credits: '30',
          price: '13.99',
          value: '$0.47/credit',
        },
        createDesigns: 'Create {{credits}} unique card designs',
      },
    },
  },
};

export default translations;
